import React, { useEffect } from 'react'

const BuilderIsolatedPage = ({ children, id = 'builder-isolated-root' }) => {
  useEffect(() => {
    document.body.style.overflow = 'auto'
    document.documentElement.style.overflow = 'auto'
  }, [])

  return (
    <>
      <style>
        {`
          #${id} {
            display: block;
            width: 100%;
            position: static;
            overflow: visible;
            height: auto;
            min-height: auto;
            flex: none;
            align-self: stretch;
          }

          #${id} * {
            box-sizing: border-box;
          }
        `}
      </style>

      <div id={id}>
        {children}
      </div>
    </>
  )
}

export default BuilderIsolatedPage
